import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {BooleanInput} from './BooleanInput';
import {StringInput} from './StringInput';
import {Column} from '../../../../stores/Form/Column';
import {fieldValue} from '../../../../stores/Form/Field';
import {isOperatorField} from '../../utils/filters';

export type InputProps = {
    column: Column;
    searchMode: boolean;
    rowIndex: number;
    value: fieldValue;
    handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    handleChange: (value: any) => void;
    inputRef: React.MutableRefObject<any>;
    isActive: boolean;
    processEventCodes: (event: KeyboardEvent) => Promise<void>;
    setMaxWidthMode: (flag: boolean) => void;
    setEditMode: (editMode: boolean) => void;
    onFocus: (e: any) => void;
    onBlur?: () => void;
};

export const FormInputComponent = ({
    column,
    searchMode,
    rowIndex,
    value,
    handleKeyDown,
    handleChange,
    inputRef,
    isActive,
    processEventCodes,
    setMaxWidthMode,
    setEditMode,
    onFocus,
    onBlur
}: InputProps) => {
    const isReadonly = column.isReadonly && !searchMode;
    if (
        !isOperatorField(searchMode, rowIndex) &&
        column.Type === priority.netitems.form.ColumnType.Boolean
    ) {
        return (
            <BooleanInput
                onKeyDown={handleKeyDown}
                value={value as boolean}
                handleChange={handleChange}
                inputRef={inputRef}
                isActive={isActive}
                isReadonly={isReadonly}
                searchMode={searchMode}
                processEventCodes={processEventCodes}
            />
        );
    } else {
        return (
            <StringInput
                column={column}
                value={value as string}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                inputRef={inputRef}
                isReadonly={isReadonly}
                searchMode={searchMode}
                setMaxWidthMode={setMaxWidthMode}
                setEditMode={setEditMode}
                rowIndex={rowIndex}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        );
    }
};
